
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { Capacitor } from '@capacitor/core';
import { memoryLock } from '../../lib/memoryLock';

const SUPABASE_URL = "https://bagohvtkkscmmxhkxtdc.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJhZ29odnRra3NjbW14aGt4dGRjIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDc3NzMxNzYsImV4cCI6MjA2MzM0OTE3Nn0.27VCslKf-NdLwQGW3XC_pk1-ZeikYD7pDD5cIX2GK1I";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

const isNative = Capacitor.isNativePlatform();

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: typeof window !== 'undefined' ? window.localStorage : undefined,
    persistSession: true,
    autoRefreshToken: true,
    // On native, OAuth returns via deep link and DeepLinkHandler processes it.
    detectSessionInUrl: !isNative,
    // navigator.locks contention stalls login in the Android WebView.
    ...(isNative ? { lock: memoryLock } : {}),
  },
});
